import { ScheduleContext } from '../../context'
import { useContextSelector } from 'use-context-selector'
import { EventsCalendar } from '@containers/EventsCalendar'

export default function Calendar() {
  const selectedDate = useContextSelector(
    ScheduleContext,
    (s) => s.selectedDate
  )
  const setSelectedDate = useContextSelector(
    ScheduleContext,
    (s) => s.setSelectedDate
  )
  const events = useContextSelector(ScheduleContext, (s) => s.events)

  const handleUpdateCalendar = useContextSelector(
    ScheduleContext,
    (s) => s.handleUpdateCalendar
  )

  const [tab, setTab] = useContextSelector(ScheduleContext, (s) => [
    s.tab,
    s.setTab,
  ])

  return (
    <EventsCalendar
      events={events}
      headerLocation="space-between"
      handleUpdateSearch={handleUpdateCalendar}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      tab={tab}
      setTab={setTab}
      hideOptionList
    />
  )
}
